'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as Styled from './styled';

const ListTab = TabsPrimitive.Root;

const ListTabList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ ...props }, ref) => <Styled.List ref={ref} {...props} />);
ListTabList.displayName = 'ListTabList';

const ListTabTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    count?: number;
  }
>(({ children, count, ...props }, ref) => (
  <Styled.Trigger ref={ref} {...props}>
    {children}
  </Styled.Trigger>
));
ListTabTrigger.displayName = 'ListTabTrigger';

const ListTabContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ ...props }, ref) => <Styled.Content ref={ref} {...props} />);
ListTabContent.displayName = 'ListTabContent';

export { ListTab, ListTabList, ListTabTrigger, ListTabContent };
